"use client";
import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { FiShare } from "react-icons/fi";
import { scaleImageUrl } from "@/utils/scaleImage";
import Modal2 from "../Modal2";
import { ShareActivityModal } from "../ShareActivityModal";
import { useDynamicLink } from "@/hooks/useDynamicLink";

interface ActivityCardProps {
  activity: Activity;
  isCategoryPage?: boolean;
}

export default function ActiveActivityCard({
  activity,
  isCategoryPage = false,
}: ActivityCardProps) {
  const [isOpen, setIsOpen] = useState(false);

  const router = useRouter();

  const { link: dynamicLink, isLoading } = useDynamicLink({
    enabled: isOpen,
    url:
      typeof window !== "undefined"
        ? `https://${window.location.hostname}/activity/${activity.id}?id=${activity.id}`
        : null,
    title: activity?.title,
    description: activity?.description,
    image: activity?.images?.[0],
  });

  const handleActivityNavigation = () => {
    router.push(`/activity/${activity.id}`);
    // if (activity?.eventType === "COMPETITION") {
    //   router.push(`/competition/${activity.id}`);
    // } else {
    //   router.push(`/activity/${activity.id}`);
    // }
  };

  return (
    <div
      onClick={handleActivityNavigation}
      className="relative bg-black h-[350px] max-h-[380px] rounded-2xl overflow-hidden shadow-lg group hover:cursor-pointer"
    >
      <Image
        src={scaleImageUrl(
          activity?.images[0] || activity?.societyAvatar,
          400,
          300
        )}
        alt={activity?.title || "Activity image"}
        width={400}
        height={300}
        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        onError={(e) => {
          e.currentTarget.src = "/assets/images/placeholder_image.webp";
        }}
      />

      <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-4">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-center uppercase font-semibold text-white">
              {activity?.category}
            </span>

            {isCategoryPage && (
              <span className="text-[10px] bg-white text-gray500 py-1 px-3 rounded-full uppercase font-semibold">
                Active
              </span>
            )}
          </div>

          <div
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(true);
            }}
            className="bg-black bg-opacity-50 p-2 rounded-full cursor-pointer hover:bg-opacity-75"
          >
            <FiShare className="text-white w-3 h-3" />
          </div>
        </div>

        <h3 className="text-white text-sm font-bold py-1">{activity?.title}</h3>
        <p className="text-white text-xs">
          {activity?.city} · {activity?.country}
        </p>
      </div>

      {activity?.verified && (
        <p className="absolute top-4 left-4 text-xs bg-white p-1 px-2 text-gray500 rounded-3xl font-medium flex items-center gap-1">
          Verified <BsFillPatchCheckFill size={10} className="text-green" />
        </p>
      )}
      {activity?.featured && (
        <p className="absolute top-4 left-4 text-xs bg-[#EFFAF6] p-1 px-2 text-green rounded-3xl font-medium">
          Featured
        </p>
      )}
      {activity?.sponsored && (
        <p className="absolute top-4 left-4 text-xs bg-[#FBDFB1] p-1 px-2 text-gray800 rounded-3xl font-medium">
          Sponsored
        </p>
      )}

      {/* Modal */}
      <div onClick={(e) => e.stopPropagation()}>
        <Modal2
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
        >
          <ShareActivityModal
            activityUrl={dynamicLink!}
            isLoading={isLoading}
          />
        </Modal2>
      </div>
    </div>
  );
}
